module.exports = require("./../../_gen/starling/textures/Texture");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/textures/Texture.js
// module id = 237
// module chunks = 0